import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiResponseModel, ApiVisa, Core2Config } from '../../shared';
import { BaseApiPublicLoginTemplateService } from '../../shared/base-api-public-login-template.service';
import { MemberLabelTopicLinkContainerModel } from '../../../../../../models';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class MemberLabelTopicLinkService extends BaseApiPublicLoginTemplateService<MemberLabelTopicLinkContainerModel, MemberLabelTopicLinkContainerModel, MemberLabelTopicLinkContainerModel> {

    static readonly MEMBER_LABEL_TOPIC_LINK_SUB_PATH = 'labels-topic-subscriptions-links/';

    constructor(http: HttpClient) {
        super();
        this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + MemberLabelTopicLinkService.MEMBER_LABEL_TOPIC_LINK_SUB_PATH + BaseApiPublicLoginTemplateService.BACKOFFICE_EP;
        this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + MemberLabelTopicLinkService.MEMBER_LABEL_TOPIC_LINK_SUB_PATH + BaseApiPublicLoginTemplateService.BACKOFFICE_EP;
        this.endpoint_path_login_url = Core2Config.TENANT_DOMAIN_URL_PREFIX + MemberLabelTopicLinkService.MEMBER_LABEL_TOPIC_LINK_SUB_PATH + BaseApiPublicLoginTemplateService.LOGIN_EP;
        this.endpoint_path_login_entity_url = Core2Config.TENANT_DOMAIN_URL_PREFIX + MemberLabelTopicLinkService.MEMBER_LABEL_TOPIC_LINK_SUB_PATH + BaseApiPublicLoginTemplateService.LOGIN_ENTITY_EP;
        this.httpClient = http;
    }

    deleteAndSyncMemberSubscription(guid: string, websiteCode: string, visa: ApiVisa): Observable<ApiResponseModel<MemberLabelTopicLinkContainerModel>> {
        let url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + MemberLabelTopicLinkService.MEMBER_LABEL_TOPIC_LINK_SUB_PATH + "delete-and-unsubscribe/backoffice-ep";
        if (visa.api_domain_url) {
            url = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + MemberLabelTopicLinkService.MEMBER_LABEL_TOPIC_LINK_SUB_PATH + "delete-and-unsubscribe/backoffice-ep";
        }
        return this.httpClient.delete<ApiResponseModel<MemberLabelTopicLinkContainerModel>>(
            url + '/' + guid + '/' + websiteCode,
            this.getHttpHeader(visa)
        );
    }

    createAndSyncMemberSubscription(memberLabelTopicLinkContainerModel: MemberLabelTopicLinkContainerModel, websiteCode: string, apiVisa: ApiVisa) {
        let url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + MemberLabelTopicLinkService.MEMBER_LABEL_TOPIC_LINK_SUB_PATH + "create-and-sync-member-subscription/" + websiteCode + "/backoffice-ep";
        if (apiVisa.api_domain_url) {
            url = apiVisa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + MemberLabelTopicLinkService.MEMBER_LABEL_TOPIC_LINK_SUB_PATH + "create-and-sync-member-subscription/" + websiteCode + "/backoffice-ep";
        }

        return this.httpClient.post<ApiResponseModel<MemberLabelTopicLinkContainerModel>>(
            url,
            memberLabelTopicLinkContainerModel,
            this.getHttpHeader(apiVisa)
        );
    }
}